function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m241 0h30v72.033h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m305.354 34.676h72.033v30h-72.033z",
  transform: "matrix(.372 -.928 .928 .372 168.35 348.115)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m376.269 81.01h72.033v30h-72.033z",
  transform: "matrix(.674 -.739 .739 .674 63.554 335.976)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m155.63 13.66h30v72.033h-30z",
  transform: "matrix(.928 -.372 .372 .928 -6.238 66.996)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m84.714 59.994h30v72.033h-30z",
  transform: "matrix(.739 -.674 .674 .739 -38.658 92.251)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m120 364h272v36h-272z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m399.167 430h-286.334c-15.324 7.889-25.833 23.861-25.833 42.25v39.75h338v-39.75c0-18.389-10.509-34.361-25.833-42.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 256c0-74.99-61.009-136-136-136s-136 61.01-136 136v78h272zm-121 40.313h-30v-30h30zm0-50.667h-30v-81.333h30z"
}));

function Svg37(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg37);
export default __webpack_public_path__ + "static/media/3_7.3bf747e6.svg";
export { ForwardRef as ReactComponent };